module.exports = __webpack_public_path__ + "static/media/r23.544eb64f.jpg";